// extracted by mini-css-extract-plugin
module.exports = {"body":"_2uTWJsFhtHCJMEVowZzY9A","pad-control":"_1qNozKDj01o_jwXOcsOoD3","dialog":"_3jsEskjNqjDNYd6R5NlGVg"};